<template>
  <div class="tableSelect">
    <div class="search" style="margin-bottom: 5px; display: flex">
      <slot name="adSearch"/>
      <el-button style="height: 29px" type="primary" @click="loadData(1)">查询</el-button>
      <el-button style="height: 29px" type="primary" plain @click="resetHandle">重置</el-button>
    </div>
    <Table
        v-loading="loading"
        :border="border"
        :stripe="stripe"
        :columns="columns"
        :data="tableData"
        max-height="400"
        @on-select="selectHandle"
        @on-select-all="selectHandle">
      <template slot="action" slot-scope="{ row }">
        <el-button type="primary" @click="selectHandle(row)">选择</el-button>
      </template>
    </Table>
    <div style="margin-top: 13px; text-align: right">
      <el-pagination
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>
  export default {
    props: { 
      module: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        required: true,
      },
      // 过滤条件
      filter: {
        type: Object,
      },
      // 边框
      border: {
        type: Boolean,
        default: true,
      },
      // 斑马线
      stripe: {
        type: Boolean,
        default: true,
      },
      columns: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        tableData: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
        },
        loading: false,
        filterCopy: JSON.stringify(this.filter),
      };
    },

    methods: {
      loadData(pageNum) {
        this.loading = true;
        if (pageNum) {
          this.pagination.currentPage = pageNum;
        }
        let params = Object.assign({ pageSize: this.pagination.pageSize, pageNum: this.pagination.currentPage }, this.filter);
        this.$http
          .get(`${this.module}`, `${this.url}`, params)
          .then((res) => {
            if (res.success) {
              this.tableData = res.data.records;
              this.pagination.total = res.data.total;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },

      handleCurrentChange(page) {
        this.pagination.currentPage = page;
        this.loadData();
      },

      handleSizeChange(pageSize) {
        this.pagination.pageSize = pageSize;
        this.loadData();
      },

      resetHandle() {
        this.$emit("reset", JSON.parse(this.filterCopy));
      },

      selectHandle(row) {
        this.$emit("select", row);
      },
    },
  };
</script>

<style lang="scss">
.tableSelect {
  .search {
    background-color: #f4f7fa;
    padding: 14px 0 0 10px;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    margin-bottom: 5px;
  }
}
</style>
